/**
 * Gets the promo code used for source tracking.
 *
 * First checks URL string for variable (i.e. ?promo=12345).
 * Otherwise, look in our TriMark coookie for the code.
 *
 * Cookie is set in partials/source-tracker.js
 *
 * @returns string
 */
function getPromoCode() {
	const urlVars = new URLSearchParams(window.location.search);
    const cookieVars = Cookies.get('trmk_src_first') ? JSON.parse(Cookies.get('trmk_src_first')) : {};

	// First check for promo code in URL
	if (urlVars.get('promo')) {
		return urlVars.get('promo');
	}

	// Otherwise fallback to cookie value
	return cookieVars.hasOwnProperty('promo') ? cookieVars.promo : false;
}

/**
 * ChatInterceptor function
 *
 * Fired by Apex chat when user interacts with chat. This allows us to hook into the
 * chat and pass through our promo code and set a default one if needed.
 *
 * @returns null
 */
window.ChatInterceptor = function() {
    try {
        let promo = getPromoCode();
		if (!promo) {
			promo = "0071";
		}
        return promo;
    } catch (e) {
        console.log(e);
    }
};
